export default {
    title: 'Filtros',
    reset: 'Limpar Filtros',

    labels: {
        actionable_id: 'ID Recurso',
        actionedBetween: 'Entre',
        active: 'Apenas Ativos',
        blocked: 'Apenas Bloqueados',
        byResellerType: 'Tipo de parceiro',
        canceled: 'Apenas Cancelados',
        canceledWithActivePlan: 'Cancelados com Plano Ativo',
        createdBetween: 'Criado entre',
        activatedBetween: 'Ativado entre',
        lastActivationNinetyDays: 'Apenas Com 90 Dias Sem Ativação',
        monthYear: 'Mês/Ano',
        onlyBadDebt: 'Apenas Inadimplentes',
        onlyNotPaid: 'Apenas Pendentes',
        onlyPaid: 'Apenas Pagos',
        onlyTrashed: 'Apenas Excluídos',
        payment_method: 'Forma de Pagamento',
        pending: 'Apenas Pendentes',
        period: 'Período',
        reseller_type_id: 'Tipo de parceiro',
        resource: 'Recurso',
        search: 'Pesquisar',
        status: 'Status',
        trial: 'Apenas Trial',
        user_id: 'ID Usuário',
        pendentCancellationRequisition:
            'Solicitações de Cancelamento Pendentes',
        trashed: 'Itens Excluídos',
        with: 'Com',
        without: 'Sem',
        only: 'Apenas',
        manager_id: 'Gerente de Conta',
        dueBetween: 'Vencimento Entre',
        showArchived: 'Exibir Arquivadas',
        actionableAttribute: 'Chave=Valor',
        byAccountManager: 'Gerente de Contas',
        initDateBetween: 'Data Inicial',
        paidBetween: 'Pago Em',
    },
}
